import { IconPropsType } from './IconTypes';

export default function DownRightArrow({ monochrome = false, className }: IconPropsType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      className={className}
    >
      <path
        d="M13.49 10L17.24 13.75M17.24 13.75L13.49 17.5M17.24 13.75H4.73999C2.53085 13.75 0.73999 11.9592 0.73999 9.75002V1.49902"
        stroke={monochrome ? 'currentColor' : '#2E3135'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
